module.exports = __webpack_public_path__ + "static/media/not-a-cheat.066f8e06.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/home/sections/marketingPoints/assets/not-a-cheat.png
 ** module id = 572
 ** module chunks = 0
 **/